export enum ParticipantRole {
  DRIVER = "DRIVER",
  NAVIGATOR = "NAVIGATOR",
}
